import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  @font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 400;
    font-display: swap;
    src: url("/assets/fonts/Inter-Regular.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-Regular.woff?v=3.11") format("woff");
  }
  @font-face {
    font-family: 'Inter';
    font-style:  italic;
    font-weight: 400;
    font-display: swap;
    src: url("/assets/fonts/Inter-Italic.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-Italic.woff?v=3.11") format("woff");
  }

  @font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 500;
    font-display: swap;
    src: url("/assets/fonts/Inter-Medium.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-Medium.woff?v=3.11") format("woff");
  }

  @font-face {
    font-family: 'Inter';
    font-style:  italic;
    font-weight: 500;
    font-display: swap;
    src: url("/assets/fonts/Inter-MediumItalic.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-MediumItalic.woff?v=3.11") format("woff");
  }

  @font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 600;
    font-display: swap;
    src: url("/assets/fonts/Inter-SemiBold.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-SemiBold.woff?v=3.11") format("woff");
  }

  @font-face {
    font-family: 'Inter';
    font-style:  normal;
    font-weight: 700;
    font-display: swap;
    src: url("/assets/fonts/Inter-Bold.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-Bold.woff?v=3.11") format("woff");
  }
  @font-face {
    font-family: 'Inter';
    font-style:  italic;
    font-weight: 700;
    font-display: swap;
    src: url("/assets/fonts/Inter-BoldItalic.woff2?v=3.11") format("woff2"),
        url("/assets/fonts/Inter-BoldItalic.woff?v=3.11") format("woff");
  }

  *,
  *::before,
  &::after {
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: ${({ theme: { font } }) => font};
    font-size: 14px;
    color: ${({ theme: { colors } }) => colors.black};
    background-color: ${({ theme: { colors } }) => colors.lightGrey};
    min-width: 1024px;
    overflow-y: scroll;

    @media (max-width: 1024px) {
      min-width: auto;
    }
  }

  #main {
    min-height: 100vh;
  }

  img,
  video {
    max-width: 100%;
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: 600;
  }

  p {
    line-height: 1.5;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px #ffffff inset !important;
    box-shadow: 0 0 0 30px #ffffff inset !important;
  }

  button {
    font: 500 1em Inter, Arial, sans-serif;
    color: ${({ theme: { colors } }) => colors.black};
  }

  input {
    font: 400 14px Inter, Arial, sans-serif;
    color: ${({ theme: { colors } }) => colors.black};
  }

  a.link,
  button.link {
    text-decoration: none;
    color: ${({ theme: { colors } }) => colors.textHighlightColor};

    &:hover {
      color: ${({ theme: { colors } }) => colors.textHighlightColorDark};
    }
  }

  .m-0 {
    margin: 0 !important;
  }

  .mt-0 {
    margin-top: 0 !important;
  }

  .mt-1 {
    margin-top: 1em !important;
  }

  .mt-2 {
    margin-top: 1.5em !important;
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .mb-1 {
    margin-bottom: 1em !important;
  }

  .mb-2 {
    margin-bottom: 1.5em !important;
  }

  .normal {
    font-weight: normal !important;
  }

  .bold {
    font-weight: 600 !important;
  }

  .medium {
    font-weight: 500;
  }

  .center {
    text-align: center;
  }

  .right {
    text-align: right;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .small {
    font-size: 0.8em;
  }

  .red {
    color: ${({ theme: { colors } }) => colors.red};
  }

  .blue {
    color: ${({ theme: { colors } }) => colors.blue} !important;
  }

  .teal {
    color: ${({ theme: { colors } }) => colors.teal};
  }

  .grey {
    color: ${({ theme: { colors } }) => colors.grey};
  }

  .light-grey {
    color: ${({ theme: { colors } }) => colors.lightGrey};
  }

  .vertical-align-middle {
    vertical-align: middle;
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme: { colors } }) => colors.grey2};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme: { colors } }) => colors.deepLightGrey};
    border-radius: 0px;
    border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};

    &:hover {
      background: ${({ theme: { colors } }) => colors.grey};
    }
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.95, 0.95);
    }

    to {
      opacity: 1;
      transform: scale(1, 1);
    }
  }

  .scaleIn {
    animation-name: scaleIn;
  }

  /* @keyframes fadeInLeft {
    0% {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }

    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }

    75% {
      transform: translate3d(10px, 0, 0);
    }

    90% {
      transform: translate3d(-5px, 0, 0);
    }

    100% {
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInLeft {
    animation-name: fadeInLeft;
  } */

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes bounceInRight {
    0%,
    60%,
    75%,
    90%,
    100% {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }

  .bounceInRight {
    animation-name: bounceInRight;
  }

  .users-form {
    input[type='text'],
    input[type='email'],
    input[type='password'],
    textarea,
    select {
      font-size: 14px;
      line-height: 1.3;
      padding: 19px 14px;
      border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
      width: 100%;
      border-radius: 4px;
      margin-top: 3px;
      box-shadow: 0 0 0 2px transparent;
      transition: all 0.1s;

      &:hover {
        border: 1px solid ${({ theme: { colors } }) => colors.grey};
      }

      &:focus {
        outline: 0;
        border: 1px solid ${({ theme: { colors } }) => colors.darkBlue};
      }
    }

    label {
      display: block;
      font-weight: 500;
      font-size: 14px;
      line-height: 2;
      color: ${({ theme: { colors } }) => colors.darkBlue};

      &.password-field {
        position: relative;

        button {
          position: absolute;
          top: 50px;
          right: 15px;
          opacity: 0.5;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }

    [type='submit'] {
      font-size: 16px;
      padding: 14px 40px;
    }

    [type='checkbox'] {
      margin-right: 10px;
    }

    .custom-select {
      position: relative;

      select {
        appearance: none;
      }

      &::after {
        content: '';
        position: absolute;
        z-index: 1;
        bottom: 26px;
        right: 15px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 4px 0 4px;
        border-color: ${({ theme: { colors } }) => colors.grey} transparent
          transparent transparent;
      }
    }

    .error {
      display: flex;
      background-color: ${({ theme: { colors } }) => colors.red}26;
      padding: 10px 14px;
      border-radius: 4px;
      overflow: auto;

      svg {
        fill: ${({ theme: { colors } }) => colors.red};
        float: left;
        margin-right: 10px;
        min-width: 20px;
      }

      span {
        color: ${({ theme: { colors } }) => colors.darkBlue};
        line-height: 1.5;
      }
    }

    &.smaller-labels {
      label {
        font-size: 14px;
      }
    }

    &.is-share {
      label {
        font-size: 12px;

        &[for="persist"] {
          margin-bottom: 0;
        }
      }

      input {
        margin-top: 0;
        padding: 13px 14px;
      }

      & > div {
        margin: 0;
      }

      button[type='submit'] {
        width: 100%;
      }
    }
  }

  #google-sign-in {
    padding: 9.5px 37px;
    border-radius: 50px;
    border: 1px solid ${({ theme }) => theme.colors.blue};
    color: ${({ theme }) => theme.colors.blue};
    line-height: 1;
    transition: 0.2s all;

    svg {
      margin-right: 14px;
    }

    &:hover {
      border: 1px solid ${({ theme }) => theme.colors.darkBlue};
      color: ${({ theme }) => theme.colors.darkBlue};
    }
  }

  .comment-at-menu-container {
    z-index: 9006;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      background-color: #ffffff;
      box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
      border-radius: 6px;

      li {
        font-weight: 500;
        margin: 0;
        padding: 7px 10px;
        background-color: #ffffff;
        cursor: pointer;

        &.highlight,
        &:hover,
        &:focus {
          background-color: ${({ theme: { colors } }) => colors.grey3};
        }

        img {
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 6px;
        }

        span {
          font-weight: 600;
        }
      }
    }
  }

  .dashboard-contact-us {
    position: fixed;
    right: 12px;
    bottom: 16px;
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 1px 2px 0 rgba(17,13,29,0.26);
    padding: 4px 9px;
    transition: all 0.2s;

    &:hover {
      box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
    }

    svg {
      margin-right: 4px;
    }

    span {
      vertical-align: middle;
      font-size: 14px;
      line-height: 1.57;
    }
  }

  .absolute-inset {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .input-number-no-arrow {
    appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }

  .input-number {
    position: relative;

    &__up,
    &__down {
      position: absolute;
      top: 0;
      right: 2px;
      z-index: 1;
      height: 12.5px;
      opacity: 0.3;

      &:hover {
        opacity: 1;
      }

      svg {
        width: 12px;
        height: 12px;
      }
    }

    &__up {
      top: -3px;
    }

    &__down {
      top: 12px;
    }
  }

  .status-tag {
    display: inline-block;
    padding: 4px 7px;
    border-radius: 20px;
    font-size: 13px;
    line-height: 15px;
    font-weight: 500;

    svg {
      margin-right: 3px;
      pointer-events: none;
    }

    &.expired {
      background-color: ${({ theme: { colors } }) => colors.deepLightGrey};
      color: ${({ theme: { colors } }) => colors.lighterBlack};
    }

    &.days {
      background-color: #ccf8dd;
      color: #30af7f;
    }

    &.approved {
      padding: 3px;
      font-size: 10px;
      color: ${({ theme }) => theme.colors.white};
      background-color: ${({ theme }) => theme.colors.orange};
      border-radius: 5px !important;

      svg {
        fill: ${({ theme }) => theme.colors.white};
      }
    }

    span {
      position: absolute;
      opacity: 0;
      pointer-events: none;
    }

    &:hover {
      span {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 26px;
    height: 14px;
    vertical-align: middle;

    &:focus {
      outline: 0;
    }

    input {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .slider {
        background-color: ${({ theme: { colors } }) => colors.teal};

        &:before {
          transform: translateX(12px);
        }
      }
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 34px;
      border: 1px solid ${({ theme: { colors } }) => colors.deepLightGrey};
      background-color: ${({ theme: { colors } }) => colors.deepLightGrey};
      transition: all 0.2s;

      &::before {
        content: '';
        position: absolute;
        height: 12px;
        width: 12px;
        left: 0;
        bottom: 0;
        border-radius: 50%;
        background-color: white;
        transition: all 0.2s;
      }
    }

    &.switch-big {
      width: 44px;
      height: 22px;

      .slider {
        &::before {
          height: 20px;
          width: 20px;
        }
      }

      input {
        &:checked + .slider {
          &:before {
            transform: translateX(22px);
          }
        }
      }
    }
  }

  .fc-open {
    bottom: 35px !important;
  }

  .dropdown-arrow {
    position: relative;
    padding-right: 12px;

    &::after {
      content: '';
      position: absolute;
      top: 7px;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 4px 3.75px 0 3.75px;
      border-color: ${({ theme: { colors } }) => colors.black} transparent
        transparent transparent;
      opacity: 0.3;
    }
  }

  @keyframes dropdownIn {
    from {
      padding: 0px 15px;
      max-height: 0;
    }

    to {
      max-height: 150px;
      padding: 10px 15px;
    }
  }

  .dropdown-menu {
    list-style: none;
    border-radius: 4px;
    background-color: #ffffff;
    margin: 0;
    padding: 0px 15px;
    height: auto;
    max-height: 0;
    overflow: hidden;
    box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
    transition: all 0.05s;
    visibility: hidden;

    &.animate {
      animation: dropdownIn 0.3s;
    }

    &.active {
      max-height: 170px;
      padding: 10px 15px;
      transition: all 0.3s;
      visibility: visible;
    }

    &.align-left {
      li {
        a,
        button {
          text-align: left;
        }
      }
    }

    &.align-right {
      li {
        a,
        button {
          text-align: right;
        }
      }
    }

    li {
      display: block;
      padding: 5px 0;
      margin: 0;

      &.active {
        a,
        button {
          color: ${({ theme: { colors } }) => colors.textHighlightColor};
        }
      }

      a,
      button {
        display: inline-block;
        width: 100%;
        color: initial;
        font-size: 15px;
        font-weight: 500;
        text-decoration: none;

        &:hover {
          color: ${({ theme: { colors } }) => colors.textHighlightColorDark};
        }
      }
    }

    &.menu-item-hover {
      padding: 0;

      &.active {
        li {
          a,
          button {
            padding: 5px 10px;
            transition: padding 0.3s;
          }
        }
      }

      li {
        padding: 0;

        button,
        a {
          padding: 2px 10px;
          transition: padding 0.05s;

          &:hover {
            background-color: ${({ theme: { colors } }) => colors.lightGrey};
            color: ${({ theme: { colors } }) => colors.black};
          }
        }
      }
    }
  }

  .tooltip {
    position: absolute;
    top: 0;
    left: 0px;
    padding: 3px 5px;
    font-size: 12px;
    color: #ffffff;
    text-transform: capitalize;
    text-align: center;
    background-color: ${({ theme: { colors } }) => colors.black};
    box-shadow: ${({ theme: { menuShadow } }) => menuShadow};
    border-radius: 4px;
    opacity: 0;
    transform: scale(0.95, 0.95);
    transform-origin: left bottom;
    transition: ${({ theme: { transition } }) => transition};
    z-index: 1;
    visibility: hidden;
    pointer-events: none;

    &-container {
      position: relative;
    }

    &-container:hover .tooltip,
    &.active {
      opacity: 1;
      transform: scale(1, 1);
      visibility: visible;
      pointer-events: all;
    }
  }

  .toast-container {
    right: 2em !important;
  }

  .toast-body {
    padding: 6px 12px !important;
    font-family: ${({ theme: { font } }) => font} !important;
    font-size: 14px !important;
    color: ${({ theme: { colors } }) => colors.black} !important;
  }

  .toast-progress-bar {
    background: ${({ theme: { colors } }) => `${colors.blue} !important`};
  }

  .sortable-ghost {
    opacity: 0 !important;
  }

  button {
    &:disabled {
      cursor: not-allowed;
    }
  }

  #floating-elements-container {
    position: relative;
    z-index: 99999;
  }
`;
